import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';


export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);
	
    useEffect(() => {
        var inputValue = {
             session: GetLocal('EmployeeSession'),
			 requestNumber: GetLocal('RequestNumber')
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowRequestReview", inputValue, ShowServiceResultSuccess);
    }, []);	
	
    const ShowServiceResultSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
    }		
	
    return (
        <div> 
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			<ShowFilesReviewAbstractList/>
			{getServiceResult ? <div>
			<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
				<tbody>
					<tr>
						<td><b class="b1">نام:</b> {getServiceResult.Gender} / {getServiceResult.ApplicantName} </td>
						<td><b class="b1">نوع:</b> {getServiceResult.ApplicantType}</td>
						<td><b class="b1">پست الکترونیک:</b> {getServiceResult.Email}</td>
					</tr>
					<tr>		
						<td><b class="b1">کد پستی:</b> {getServiceResult.PostalCode}</td>
						<td><b class="b1">شماره تلفن:</b> {getServiceResult.PhoneNumber}</td>
						<td><b class="b1">دورنگار:</b> {getServiceResult.FaxNumber}</td>
					</tr>
					<tr>	
						<td><b class="b1">شماره پیام کوتاه:</b> {getServiceResult.CellNumber}</td>
						<td colspan="2"><b class="b1">نشانی:</b> {getServiceResult.Description}</td>						
					</tr>	
				</tbody>
			</table>
			<br/>
			<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
				<tbody>
					<tr>
						<td><b class="b1">نوع درخواست:</b> {getServiceResult.RequestTitle}</td>
						<td><b class="b1">شماره نامه:</b> {getServiceResult.LetterNumber}</td>
						<td><b class="b1">بازدید کننده:</b> {getServiceResult.Visitor}</td>
					</tr>
					<tr>	
						<td><b class="b1">تاریخ بازدید:</b> {getServiceResult.ReviewDate}</td>
						<td><b class="b1">تاریخ نامه:</b> {getServiceResult.LetterDate}</td>
						<td><b class="b1">مامور بازدید:</b> {getServiceResult.ReviewerName}</td>
					</tr>
					<tr>	
						{/*<td><b class="b1">تعداد بازدید:</b> {getServiceResult.ReviewCount}</td>*/}
						<td colspan="3"><b class="b1">توضیحات:</b> {getServiceResult.Description}</td>					
					</tr>	
				</tbody>
			</table>				
        </div>
		:
			<div className="alert alert-danger text-center">موردی یافت نشد.</div>
		}
		</div>
    );
}
